import { TicketDeliveryMethod } from '@features/modal-invitation/api/updateSetting';

const TICKET_DELIVERY_METHOD_LABELS: Record<TicketDeliveryMethod, string> = {
  [TicketDeliveryMethod.SMS]: 'СМС',
  [TicketDeliveryMethod.Email]: 'Email',
  [TicketDeliveryMethod.Both]: 'СМС и Email',
  [TicketDeliveryMethod.VK]: 'VK Teams',
};

export const formatTicketDeliveryMethods = (methods: TicketDeliveryMethod[] | null | undefined): string => {
  if (!methods?.length) {
    return '-';
  }

  return methods.map((method) => TICKET_DELIVERY_METHOD_LABELS[method] ?? method).join(', ');
};
